import { useNavigate, useParams } from 'react-router-dom';
import Table from '../../../ui/Table';
import { ValidationOverviewData } from '../../../constants/validationOverviewData';
import Tag from '../../../ui/Tag';
import Button from '../../../ui/Button';
import { getCreationOrValidationRequestsOrProposals } from '../../../apis/treasurer/treasurer';
import { useContext, useEffect, useState } from 'react';
import NoDataAvailable from '../../../ui/NoDataAvailable';
import Loader from '../../../ui/Loader';
import { formatIntDateAndThenTime } from '../../../helpers/formatInDateAndThenTime';
import { executorToFindIfUserHasVoted } from '../../../blockchainInteraction/votingOnProposals';
import { AuthContext } from '../../../contexts/AuthContext';
import { clusterApiUrl, Connection } from '@solana/web3.js';
import { PublicKey } from '@solana/web3.js';
import { VOTING_STATUS_COLOR } from '../../../constants/datas';
import VotedTickRed from '../../../assets/icons/VotedTickRed';
import VotedTick from '../../../assets/icons/VotedTick';
import { RPC_ENDPOINT } from '../../../constants/apiPaths';

const fetchValueForRow = async (rowId, walletAddress, multiSig) => {
    const connection = new Connection(RPC_ENDPOINT, 'confirmed');
    try {
        const hasUserVoted = await executorToFindIfUserHasVoted(
            connection,
            new PublicKey(rowId),
            new PublicKey(walletAddress),
            multiSig
        );
        // if (data.length) onRowSelection(0, data[0]._id);
        return hasUserVoted;
    } catch (error) {
        return null;
    }
};

function BountyCreationProposals({
    onRowSelection,
    creationProposals,
    handleSetCreationProposals,
    activeCreationProposal,
    fetchedValues,
    setFetchedValues,
    multiSig,
}) {
    const navigate = useNavigate();

    // const [creationProposals, setCreationProposals] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const { state } = useContext(AuthContext);
    const { user } = state;
    const userProfile = user[0];
    const { id } = useParams();
    useEffect(
        function () {
            const fetchData = async () => {
                try {
                    const data = await getCreationOrValidationRequestsOrProposals('BOUNTY_CREATION', id, true);

                    handleSetCreationProposals(data);
                    setIsLoading(false);
                    if (data.length) onRowSelection(0, data[0]._id);
                } catch (error) {
                    console.log(error);
                }
            };
            fetchData();
        },
        [id]
    );

    useEffect(() => {
        // This effect will run when the component mounts and whenever `rows` changes.
        creationProposals?.forEach(async (row) => {
            if (!fetchedValues[row.proposalAddress]) {
                const value = await fetchValueForRow(row.proposalAddress, userProfile.walletAddress, multiSig);
                setFetchedValues((prevValues) => ({
                    ...prevValues,
                    [row.proposalAddress]: value,
                }));
            }
        });
    }, [creationProposals]);

    return (
        <div className="min-h-[60vh]">
            <Table.Header>
                <p className="text-sm   font-semibold text-secondaryText  "> Bounty ID </p>
                <p className="text-sm   font-semibold text-secondaryText  ">Bounty Name</p>
                <p className="text-sm   font-semibold text-secondaryText  ">Proposal Created Time</p>
                <p className="text-sm   font-semibold text-secondaryText  ">Status</p>
            </Table.Header>
            {isLoading ? (
                <div className="min-h-[20vh] flex justify-center items-center">
                    <Loader />
                </div>
            ) : creationProposals.length ? (
                creationProposals.map((overviewrow, index) => (
                    <Table.Row
                        key={overviewrow._id}
                        rowClassName={`cursor-pointer ${activeCreationProposal === index ? 'bg-update' : ''}  `}
                        onClick={() => onRowSelection(index, overviewrow._id)}
                    >
                        <p
                            onClick={() => navigate(`/organizations/${id}/view-bounties/${overviewrow.bountyId}`)}
                            className=" text-textBrandBlue cursor-pointer truncate w-full uppercase justify-self-start font-medium "
                        >
                            {overviewrow.bountyId}
                        </p>
                        <p className=" cursor-pointer truncate text-textPrimary  ">{overviewrow.bountyTitle}</p>

                        <p className="text-textPrimary ">
                            {formatIntDateAndThenTime(overviewrow.proposalCreationTime)}
                        </p>
                        <div className=" ">
                            {fetchedValues[overviewrow.proposalAddress] ? (
                                <Tag
                                    rounded="rounded-lg "
                                    className="px-2 py-1 leading-3   "
                                    textClassName="text-xs  font-semibold capitalize"
                                    bg={VOTING_STATUS_COLOR[fetchedValues[overviewrow.proposalAddress]]?.bg}
                                    textColor={VOTING_STATUS_COLOR[fetchedValues[overviewrow.proposalAddress]]?.text}
                                    icon={
                                        fetchedValues[overviewrow.proposalAddress] === 'not voted' ||
                                        fetchedValues[overviewrow.proposalAddress] ===
                                            'ready to execute' ? null : fetchedValues[overviewrow.proposalAddress] ===
                                          'voted yes' ? (
                                            <VotedTick />
                                        ) : (
                                            <VotedTickRed />
                                        )
                                    }
                                    text={
                                        fetchedValues[overviewrow.proposalAddress] === 'ready to execute'
                                            ? 'Ready To Execute'
                                            : fetchedValues[overviewrow.proposalAddress] === 'not voted'
                                            ? 'Ready for your vote'
                                            : fetchedValues[overviewrow.proposalAddress].split(' ').join('-')
                                    }
                                />
                            ) : (
                                'Loading...'
                            )}
                        </div>
                    </Table.Row>
                ))
            ) : (
                <NoDataAvailable />
            )}
        </div>
    );
}

export default BountyCreationProposals;
